<template>
	<div class="dashboard-container">
		<div class="waititle" style="display: flex;">
			<div style="flex: 1;display: flex;font-weight: bold;">
				<div class="blue" />
				商品数据概括
			</div>
			<div class="attributes" style="transform: translate(0,-3px)">
				<div class="attributes_title" style="display: flex;">
					<div style="font-weight: 400;line-height: 30px;">时间筛选：</div>
					<el-select size="small" v-model="user" style="width: 110px;margin-right:10px;" placeholder="请选择">
						<el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value" />
					</el-select>
					<el-date-picker size="small" v-model="data" type="date" style="margin-right:10px;"
						placeholder="选择日期" />
					<el-button type="primary" size="small">导出</el-button>
				</div>
			</div>
		</div>
		<div class="showlist2s" style="margin-top: -17px;">
			<div class="showlist2">
				<div class="waititle" style="font-weight: bold;">
					<div class="blue" />
					用户转化
				</div>
				<div class="conversion">
					<div class="conversion_1">
						<div class="conversion_1_list">
							<div class="lists">
								<div>小程序访客数</div>
								<div>5000</div>
								<div>
									日环比
									<span style="color: red;">25%</span>
								</div>
							</div>
						</div>
						<div class="conversion_1_list">
							<div class="lists">
								<div>访客取号数</div>
								<div>5000</div>
								<div>
									日环比
									<span style="color: red;">25%</span>
								</div>
							</div>
						</div>
						<div class="conversion_1_list">
							<div class="lists">
								<div>支付人数</div>
								<div>5000</div>
								<div>
									日环比
									<span style="color: red;">25%</span>
								</div>
							</div>
							<div class="lists">
								<div>支付订单数</div>
								<div>5000</div>
								<div>
									日环比
									<span style="color: red;">25%</span>
								</div>
							</div>
						</div>
						<div class="loudou">
							<div class="loudouname">
								<p>访客数</p>
								<p>取号人数</p>
								<p>支付人数</p>
							</div>
							<ve-funnel :data="chartDataloudou" :legend-visible="false" :settings="chartSettings" />
						</div>
					</div>
					<div class="conversion_2">
						<div class="xiantiao">
							<img src="../../../assets/xiantiao.png">
							<div class="rate">
								<div class="rate1 rates">
									<p>转化率</p>
									<p>30%</p>
								</div>
								<div class="rate2 rates">
									<p>转化率</p>
									<p>30%</p>
								</div>
								<div class="rate3 rates">
									<p>转化率</p>
									<p>30%</p>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="tubiao"><ve-line :data="chartData" legend-position="cener" :extend="typeExted_1"
						height="380px" /></div>
			</div>
		</div>
		<!-- 第四节 -->
		<div class="waititle" style="display: flex;margin-top: 15px;">
			<div style="flex: 1;display: flex;font-weight: bold;">
				<div class="blue" />
				交易概况
			</div>
			<div class="attributes" style="transform: translate(0,-3px)">
				<div class="attributes_title" style="display: flex;">
					<div style="font-weight: 400;line-height: 30px;">时间筛选：</div>
					<el-select size="small" v-model="user" style="width: 110px;margin-right:10px;" placeholder="请选择">
						<el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value" />
					</el-select>
					<el-date-picker size="small" v-model="data" type="date" style="margin-right:10px;"
						placeholder="选择日期" />
					<el-button type="primary" size="small">导出</el-button>
				</div>
			</div>
		</div>
		<div class="showlist2s">
			<div class="showlist2" style="height:20px;margin-top: 5px;">

				<div class="attributes_bottom">
					<div class="newo">
						<div class="newo1">
							<ve-ring :settings="chartSettings" :data="chartData_huan" legend-position="right"
								:judge-width="true" :extend="sextend2"></ve-ring>
						</div>
						<div class="newo2">
							<div class="new2_table">
								<el-table :data="tableData" border :header-cell-style="{background:'#F7F7F7'}">
									<el-table-column prop="date" width="180" />
									<el-table-column prop="name" label="付款金额" width="180" />
									<el-table-column prop="address" label="较前一个月" />
									<el-table-column prop="address" label="付款人数" />
									<el-table-column prop="address" label="较前一个月" />
								</el-table>
							</div>
						</div>
					</div>
					<div class="lastbiao" style="margin-top:-70px;">
						<div class="lasttitle" style="color: #777578;">订单分布</div>
						<ve-histogram :data="chartData_last" :setting="chartSettings" :legend-visible="false"
							:extend="sextend3"></ve-histogram>
					</div>
				</div>
				<!-- 结束 -->
			</div>
			<!-- 最后一节 -->
			<!-- 6.用户评价 -->
		</div>
	</div>
</template>
<script>
	export default {
		data() {
			this.chartSettings = {
				label: {
					normal: {
						show: false,
					}
				}
			}
			this.chartExtend = {
				color: ['#FB697E', '#845FFD']
			}
			return {
				evlData: {
					columns: ["类型", "数量"],
					rows: [{
						类型: "剪发",
						数量: 1530
					}, {
						类型: "儿童剪",
						数量: 2393
					}, {
						类型: "刘海剪",
						数量: 2393
					}],
				},
				typeExted_1: {
					legend: {
						icon: "circle"
					},
					series: {
						center: ["60%", "40%"]
					},
					color: ['#25E5C8', '#FD7C36', '#FD6880', '#8364F7', '#FB697E', '#40A2F6']
				},
				evlExted: {
					series: {
						center: ["40%", "50%"],
					},
					legend: {
						left: 0,
						icon: "circle",
						itemWidth: 10,
						itemHeight: 10,
						itemGap: 20,
					},
				},
				sextend: {
					legend: {
						icon: "circle",
						right: 140,
						top: 100
					},
					series: {
						center: ["25%", "40%"]
					},
					color: ['#409EFC', '#FB697E']
				},
				evlColor: ["#FFA242", "#2DDFCF", "#FA6A7D", "#FB697E", "#845FFC"],
				sextend2: {
					legend: {
						right: 40,
						top: 120,
						icon: "circle",
						itemWidth: 10,
						itemHeight: 10,
						itemGap: 20,
					},
					// legend:{icon:"circle",right:40,top:90},
					series: {
						center: ["30%", "40%"]
					},
					color: ['#2EDECE', '#845FFD']
				},
				sextend3: {
					color: ['#2ADFCB']
				},
				tableData: [{
					date: '2016-05-02',
					name: '王小虎',
					address: '上海市普陀区金沙江路 1518 弄'
				}, {
					date: '2016-05-04',
					name: '王小虎',
					address: '上海市普陀区金沙江路 1517 弄'
				}],
				user: '',
				listtime: '',
				data: '',
				friendsnum: [{
					name: '累计会员数'
				}],
				options: [{
					value: '选项1',
					label: '黄金糕'
				}, {
					value: '选项2',
					label: '双皮奶'
				}, {
					value: '选项3',
					label: '蚵仔煎'
				}, {
					value: '选项4',
					label: '龙须面'
				}, {
					value: '选项5',
					label: '北京烤鸭'
				}],
				option2: [{
					value: '选项1',
					label: '今天'
				}, {
					value: '选项2',
					label: '明天'
				}, {
					value: '选项3',
					label: '后天'
				}, {
					value: '选项4',
					label: '龙须面'
				}, {
					value: '选项5',
					label: '北京烤鸭'
				}],
				chartData: {
					columns: ['日期', '结算金额(元)', '付款用户数', '客单价(元)', '下单用户数', '访客数'],
					rows: [{
						日期: '1/1',
						"结算金额(元)": 1393,
						"付款用户数": 2093,
						"客单价(元)": 993,
						"下单用户数": 2385,
						'访客数': 1235
					}, {
						日期: '1/2',
						"结算金额(元)": 1393,
						"付款用户数": 1393,
						"客单价(元)": 1093,
						"下单用户数": 2485,
						'访客数': 1235
					}, {
						日期: '1/3',
						"结算金额(元)": 1363,
						"付款用户数": 2093,
						"客单价(元)": 1093,
						"下单用户数": 2385,
						'访客数': 1235
					}, {
						日期: '1/4',
						"结算金额(元)": 1393,
						"付款用户数": 2093,
						"客单价(元)": 1093,
						"下单用户数": 2385,
						'访客数': 1235
					}, {
						日期: '1/5',
						"结算金额(元)": 2093,
						"付款用户数": 2093,
						"客单价(元)": 2093,
						"下单用户数": 2385,
						'访客数': 1235
					}, {
						日期: '1/6',
						"结算金额(元)": 1393,
						"付款用户数": 2093,
						"客单价(元)": 1093,
						"下单用户数": 2385,
						'访客数': 1235
					}, {
						日期: '1/7',
						"结算金额(元)": 1393,
						"付款用户数": 2093,
						"客单价(元)": 1093,
						"下单用户数": 1285,
						'访客数': 1235
					}, {
						日期: '1/8',
						"结算金额(元)": 1323,
						"付款用户数": 2093,
						"客单价(元)": 1093,
						"下单用户数": 2335,
						'访客数': 1235
					}, {
						日期: '1/9',
						"结算金额(元)": 1393,
						"付款用户数": 5093,
						"客单价(元)": 4093,
						"下单用户数": 2085,
						'访客数': 1235
					}]
				},
				chartDataloudou: {
					columns: ['状态', '数值'],
					rows: [{
						状态: '访客数',
						数值: 100
					}, {
						状态: '取号人数',
						数值: 300
					}, {
						状态: '支付人数',
						数值: 600
					}]
				},
				chartData_last: {
					columns: ['日期', '访问用户', '下单用户', '下单率'],
					rows: [{
						'日期': '1/1',
						'下单用户': 1093,
						'下单率': 0.32
					}, {
						'日期': '1/2',
						'下单用户': 3230,
						'下单率': 0.26
					}, {
						'日期': '1/3',
						'下单用户': 2623,
						'下单率': 0.76
					}, {
						'日期': '1/4',
						'下单用户': 1423,
						'下单率': 0.49
					}, {
						'日期': '1/5',
						'下单用户': 3492,
						'下单率': 0.323
					}, {
						'日期': '1/6',
						'下单用户': 4293,
						'下单率': 0.78
					}]
				},
				chartData_huan: {
					columns: ['日期', '访问用户'],
					rows: [{
						日期: '新付费用户结算金额',
						访问用户: 1393
					}, {
						日期: '老付费用户结算金额',
						访问用户: 3530
					}]
				},
				chartData2: {
					columns: ['日期', '访问用户'],
					rows: [{
						'日期': '新客户',
						'访问用户': 3530
					}, {
						'日期': '老客户',
						'访问用户': 1393
					}]
				}
			}
		},
		mounted() {},
		methods: {
			handleClick(tab, event) {
				console.log(tab, event)
			}
		}
	}
</script>

<style scoped="scoped" lang="less">
	.waititle {
		font-weight: bold;
		display: flex;
		font-size: 16px;
		font-family: Source Han Sans CN;
		font-weight: 400;
		color: #3e3e3e;

		.blue {
			width: 5px;
			position: relative;
			top: 3px;
			height: 15px;
			background: #409eff;
			border-radius: 2px;
			margin-right: 10px;
			margin-bottom: 20px;
		}
	}

	.dashboard-container {
		box-sizing: border-box;

		.showlist_top {
			width: 100%;
			height: 135px;
			display: flex;

			.showlist_top1 {
				box-sizing: border-box;
				padding: 20px;
				flex: 1;
				margin-left: 20px;
				background: #f2f2f2;
				border-radius: 6px;

				>div {
					&:nth-child(1) {
						font-size: 14px;
						font-family: Source Han Sans CN;
						font-weight: 400;
						color: #3e3e3e;
					}

					&:nth-child(2) {
						font-size: 20px;
						margin-top: 10px;
						font-size: 36px;
						font-family: Source Han Sans CN;
						font-weight: 400;
						color: #3e3e3e;
					}
				}

				.bili {
					margin-top: 10px;
					display: flex;
					font-size: 14px;

					>div {
						&:nth-child(2) {
							margin-left: 10px;
						}
					}
				}

				&:nth-child(1) {
					margin: 0;
				}
			}
		}

		//
		.showlist2s {
			width: 100%;
			padding: 4px;
			box-sizing: border-box;
		}

		.showlist2 {
			padding: 20px;
			box-sizing: border-box;
			margin-top: 20px;
			width: 100%;
			background: #ffffff;
			box-shadow: 0px 2px 9px 0px rgba(#0000, 0.09);

			.tubiao {
				margin-top: 20px;
			}

			.conversion {
				width: 100%;
				height: 100%;
				display: flex;

				.conversion_1 {
					flex: 1.8;
					position: relative;

					.conversion_1_list {
						display: flex;
						line-height: 32px;
						border-bottom: 1px solid #e7e7e7;
						padding-bottom: 20px;
						margin-top: 10px;

						&:nth-child(3) {
							border: none;
						}

						.lists {
							margin-left: 60px;
						}
					}

					//
					.loudou {
						width: 350px;
						top: 50%;
						margin-top: -225px;
						position: absolute;
						right: -200px;

						.loudouname {
							pointer-events: none;
							font-size: 11px;
							z-index: 100;
							position: absolute;
							width: 190px;
							text-align: center;
							left: 80px;
							color: white;

							p {
								&:nth-child(1) {
									margin-top: 100px;
								}

								&:nth-child(2) {
									margin-top: 80px;
								}

								&:nth-child(3) {
									margin-top: 50px;
								}
							}
						}
					}
				}

				.conversion_2 {
					flex: 1;

					.xiantiao {
						width: 180px;
						height: 200px;
						margin-left: 50px;
						margin-top: 80px;
						position: relative;

						img {
							display: block;
							margin-left: 30px;
							width: 180px;
							height: 200px;
						}

						.rate {
							position: absolute;
							width: 200px;
							height: 180px;
							right: 0;
							top: 0;

							.rates {
								line-height: 2px;
							}

							.rate1 {
								top: 30px;
								right: -28px;
								position: absolute;
							}

							.rate2 {
								top: 110px;
								right: -28px;
								position: absolute;
							}

							.rate3 {
								top: 70px;
								right: -98px;
								position: absolute;
							}
						}
					}
				}
			}

			//
			.attributes_con {
				display: flex;

				.attributes_con1 {
					flex: 1;

					&:nth-child(1) {
						box-sizing: border-box;
					}
				}

				.shuxian {
					border-left: 1px solid #e7e7e7;
					height: 220px;
					margin-top: 50px;
				}

				.attributes_con2 {
					display: flex;

					>div {
						font-size: 18px;
						font-family: Source Han Sans CN;
						font-weight: 400;
						flex: 1;
						margin-top: 40px;
						text-align: center;

						>p {
							&:nth-child(1) {
								color: #9A9A9A;
							}

							margin-top: 40px;

						}
					}
				}

				.attributes_1 {
					display: flex;

					.con1_tu {
						flex: 1;
						display: flex;

						>div {
							flex: 1;
						}

						.con1_title {
							.con1_titles {
								padding-top: 80px;
								display: flex;

								.con1_title1 {
									display: flex;
									margin-right: 50px;
									margin-left: 40px;

									&:nth-child(1) {}

									.yuan_blue {
										width: 10px;
										height: 10px;
										background-color: blue;
										border-radius: 50%;
										margin-top: 3px;
										margin-right: 5px;
									}

								}
							}
						}
					}
				}
			}

			.attributes_bottom {
				position: relative;
				top: -20px;
			}
		}
	}

	.new_and_old_warp {
		margin-top: 25px;
	}

	.newolder {
		margin-top: 15px;
	}

	.newo {
		display: flex;
		width: 100%;
	}

	.newo1 {
		flex: 2;
	}

	.newo2_title {
		flex: 1;
	}

	.newo2 {
		flex: 3.5;
		margin-top: 50px;
	}

	.newo2_title {
		margin-top: 45px;
		margin-bottom: 45px;
		display: flex;
	}

	.newo2_title>div {
		box-sizing: border-box;
		display: flex;
		flex: 1;
		font-size: 16px;
		font-family: Source Han Sans CN;
		font-weight: 400;
		color: #3E3E3E;
	}

	.yuan1 {
		position: relative;
		top: 4px;
		left: -8px;
		width: 10px;
		height: 10px;
		background: #FB697E;
		border-radius: 50%;
	}

	.yuan2 {
		position: relative;
		top: 4px;
		left: -8px;
		width: 10px;
		height: 10px;
		background: #845FFD;
		border-radius: 50%;
	}

	.new2_table {
		box-sizing: border-box;
		padding-right: 20px;
	}

	.demo3 {
		margin-top: 20px;
		display: flex;
	}

	.demo3>div:nth-child(1) {
		flex: 3.2;
	}

	.demo3>div:nth-child(2) {
		flex: 2;
	}

	.demo3>div:nth-child(1) {
		margin-right: 20px;
	}
</style>